module.exports = __webpack_public_path__ + "media/images/flags/GY-0300dfea9113839c533440925bf2995b.svg";